import { ErrorCode, type ErrorField, type ResolvedError } from "./types"

type ErrorDefinition = {
    message: string
    fields: ErrorField[]
}

export const ERROR_MESSAGES: Record<ErrorCode, ErrorDefinition> = {
    [ErrorCode.UNKNOWN]: {
        message: "An unexpected error occurred. Please try again.",
        fields: ["general"],
    },
    [ErrorCode.PASSWORD_TOO_SHORT]: {
        message: "Password must be at least 8 characters long.",
        fields: ["password", "confirmPassword"],
    },
    [ErrorCode.PASSWORD_MISMATCH]: {
        message: "Passwords do not match.",
        fields: ["password", "confirmPassword"],
    },
    [ErrorCode.PASSWORD_WEAK]: {
        message: "Password is too weak. Use a mix of letters, numbers, and symbols.",
        fields: ["password", "confirmPassword"],
    },
    [ErrorCode.EMAIL_INVALID]: {
        message: "Please enter a valid email address.",
        fields: ["email"],
    },
    [ErrorCode.EMAIL_ALREADY_EXISTS]: {
        message: "An account with this email already exists.",
        fields: ["email"],
    },
    [ErrorCode.INVALID_CREDENTIALS]: {
        message: "Invalid email or password.",
        fields: ["email", "password"],
    },
    [ErrorCode.USER_NOT_FOUND]: {
        message: "No account found with this email.",
        fields: ["email"],
    },
    [ErrorCode.NETWORK_ERROR]: {
        message: "Network error. Please check your connection.",
        fields: ["general"],
    },
    [ErrorCode.RATE_LIMITED]: {
        message: "Too many attempts. Please wait and try again.",
        fields: ["general"],
    },
    [ErrorCode.REQUIRED_FIELD]: {
        message: "This field is required.",
        fields: ["general"],
    },
}

export function getErrorDetails(code: ErrorCode): ResolvedError {
    const def = ERROR_MESSAGES[code]
    return {
        code,
        message: def.message,
        fields: def.fields,
    }
}
